import Manufacturers from './PaymentMethods'

export default Manufacturers;


// WEBPACK FOOTER //
// ./src/components/Query/PaymentMethods/index.ts